import React from 'react';
import PropTypes from 'prop-types';
import {Alert, Col, Form, FormGroup, Input, Label} from "reactstrap";
import Button from "./Button";
import api from "../api";
import './loginPage.scss'

const LoginPage = props => {
  const [errorMsg, setErrorMsg] = React.useState('');
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const login = (e) => {
    e.preventDefault()
    if(!username || !password){
      return;
    }

    setLoading(true)
    setErrorMsg('')

    api.user.login({
      username,
      password
    })
      .then(data => {
        localStorage.jwt = data.token
        props.onSuccess()
      })
      .catch(res => setErrorMsg(res.response.data.error.message))
      .finally(() => setLoading(false))
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{height: '100vh'}}>
      <img src="//swpanel.pl/img/swpanel/logo.png" className="mb-3" />
      <div className="border px-5 py-3 login-box">
        <h1 class={"text-center mb-3"}>Logowanie</h1>
        <Alert color="warning">Aby wypełnić tę ankietę musisz się zalogować na swoje konto w swpanel.pl</Alert>

        <div className="integrations">
          <a href={process.env.PANEL_HOST + '/connect/facebook'}>
            <div className="facebook login-button" onClick="">
              <span className="icon fab fa-facebook-f"></span>
              <span className="text">Kontynuuj przez Facebook</span>
            </div>
          </a>
          <a href={process.env.PANEL_HOST + '/connect/google'}>
            <div className="google login-button" onClick="">
              <span className="icon fab fa-google"></span>
              <span className="text">Kontynuuj przez Google</span>
            </div>
          </a>
        </div>
        <Form className="mx-auto">
          {errorMsg && <FormGroup row className="mb-0">
            <Alert className="w-100" color="danger">{errorMsg}</Alert>
          </FormGroup>}
          <FormGroup>
            <Input class={"form-control w-100"} className={"email"} type="text" size={'sm'} placeholder={'Wpisz tutaj swój email'} onChange={e => setUsername(e.target.value)} value={username} />
          </FormGroup>
          <FormGroup>
            <Input class={"form-control w-100"} className={"password"} type="password" size={'sm'} placeholder={'Hasło'} onChange={e => setPassword(e.target.value)} value={password} />
          </FormGroup>
          <FormGroup className="mb-1">
            <Button className="mx-auto" onClick={login} loading={loading}>Zaloguj się</Button>
          </FormGroup>
          <div className="mx-0 w-100 text-left position-relative">
            <a href={process.env.PANEL_HOST + '/logowanie/przypomnij-haslo'} className="text-secondary forgot-password link">Zapomniałeś hasła</a>
          </div>
          <div className="mx-0 w-100 text-left position-relative mt-3">
            <a href={process.env.PANEL_HOST + '/rejestracja'} className="text-secondary link">Nie masz konta? Zarejestruj się</a>
          </div>
        </Form>
      </div>
    </div>
  );
};

LoginPage.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default LoginPage;